import { render } from "./view-tnc.vue?vue&type=template&id=c284c526&scoped=true"
import script from "./view-tnc.vue?vue&type=script&lang=js"
export * from "./view-tnc.vue?vue&type=script&lang=js"

import "./view-tnc.vue?vue&type=style&index=0&id=c284c526&scoped=true&lang=css"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c284c526"]])

export default __exports__